import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
import './registerServiceWorker'
import router from './router'
import store from './store'
import './assets/css/index.css'

Vue.config.productionTip = false

Vue.use(ElementUI)

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')

//设置当前登录账户id
store.dispatch('setMember','member');